const ATTR_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id",
  "fbclid",
];

const COOKIE = "s3_attr";
const MAX_AGE = 60 * 60 * 24 * 30;

function readCookie(name) {
  const prefix = `${name}=`;
  const hit = document.cookie.split("; ").find((x) => x.startsWith(prefix));
  return hit ? hit.slice(prefix.length) : undefined;
}

export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
  const values = {};
  for (const key of ATTR_KEYS) {
    const value = params.get(key);
    if (value) values[key] = value;
  }
  if (!Object.keys(values).length) return;

  let merged = {};
  try {
    merged = JSON.parse(decodeURIComponent(readCookie(COOKIE) || "{}"));
  } catch {
    merged = {};
  }
  merged = { ...merged, ...values, captured_at: new Date().toISOString() };

  const host = window.location.hostname;
  const domain =
    host === "section3.ai" || host.endsWith(".section3.ai") ? "; Domain=.section3.ai" : "";
  document.cookie =
    `${COOKIE}=${encodeURIComponent(JSON.stringify(merged))}` +
    `; Max-Age=${MAX_AGE}; Path=/${domain}; SameSite=Lax` +
    (window.location.protocol === "https:" ? "; Secure" : "");
}

export function getAttribution() {
  let stored = {};
  try {
    stored = JSON.parse(decodeURIComponent(readCookie(COOKIE) || "{}"));
  } catch {
    stored = {};
  }
  delete stored.captured_at;
  const out = { ...stored };
  const fbp = readCookie("_fbp");
  const fbc = readCookie("_fbc");
  if (fbp) out.fbp = fbp;
  if (fbc) out.fbc = fbc;
  return out;
}
